<template >
  <el-checkbox-group v-model="vals" @change="onCheckboxChange">
    <slot></slot>
  </el-checkbox-group>
</template>
<script>
/**
 * @description: 本组件实现item不限时只能单选，其他非不限item一起选择时可以多选
 * @return {*}
 */
export default {
  props: {
    value: {
      type: Array
    }
  },
  computed: {
    vals: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },

  methods: {
    onCheckboxChange(vals) {
      const [firstLabel] = vals
      const len = vals.length

      if (len === 0) {
        this.vals = [0]
      }
      if (firstLabel !== 0 && vals.includes(0)) {
        this.vals = [0]
      }

      if (firstLabel === 0 && len > 1) {
        this.vals = vals.filter((p) => p !== 0)
      }
      this.$emit('onCheckboxChange', vals)
    }
  }
}
</script>
